import { map } from "rxjs";
import { POST } from "../../../../module/services/fetch";

export const fetchGetAllAudits = (payload: any) => {
  const { callBody, sortBy } = payload;
  return POST(
    `admin/audits/find${
      sortBy && sortBy.length > 0
        ? `?sortField=${
            sortBy[0].id === "auditOperation" ? "operation" : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? "desc" : "asc"}`
        : ""
    }`,
    callBody
  ).pipe(map((response: any) => response));
};
